<template>
  <div>
    <a-drawer
      :width="1060"
      placement="right"
      :visible="visibleTree"
      @close="onClose"
    >
      <div class="tree-content">
        <div class="search">
          <a-date-picker
            :value="treeForm.year"
            mode="year"
            :open="isOpen"
            format="YYYY"
            placeholder="开始年"
            @openChange="handleOpenChange"
            @panelChange="handlePanelChange"
            @change="handleChange"
          />
        </div>
        <div id="container" style="width:1000px;height:900px;"></div>
        <div style="text-align:center;margin-bottom:20px;">
          <a-button
            type="primary"
            :style="{ marginRight: '8px' }"
            @click="onClose"
          >
            关闭
          </a-button>
        </div>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { getDupont } from '../api'
import G6 from '@antv/g6'
import moment from 'moment'
import insertCss from 'insert-css'

export default {
  props: ['form'],
  data() {
    return {
      visibleTree: false,
      treeForm: {
        year: this.getYear,
        customerCode: this.form.customerCode,
      },
      dupontData: {},
      isOpen: false,
      result: {},
      graph: null,
      data: {},
      container: null,
    }
  },
  methods: {
    regist() {
      G6.registerEdge(
        'circle-running',
        {
          afterDraw(cfg, group) {
            // get the first shape in the group, it is the edge's path here=
            const shape = group.get('children')[0]
            // the start position of the edge's path
            const startPoint = shape.getPoint(0)

            // add red circle shape
            const circle = group.addShape('circle', {
              attrs: {
                x: startPoint.x,
                y: startPoint.y,
                fill: '#1890ff',
                r: 3,
              },
              name: 'circle-shape',
            })

            // animation for the red circle
            circle.animate(
              ratio => {
                // the operations in each frame. Ratio ranges from 0 to 1 indicating the prograss of the animation. Returns the modified configurations
                // get the position on the edge according to the ratio
                const tmpPoint = shape.getPoint(ratio)
                // returns the modified configurations here, x and y here
                return {
                  x: tmpPoint.x,
                  y: tmpPoint.y,
                }
              },
              {
                repeat: false, // Whether executes the animation repeatly
                duration: 3000, // the duration for executing once
              },
            )
          },
        },
        'line', // extend the built-in edge 'cubic'
      )
    },
    renderGraph() {
      if (this.graph) {
        this.clear()
      }
      //circle
      this.regist()
      this.container = null
      this.container = document.getElementById('container')
      //init
      this.graph = new G6.Graph({
        container: this.container,
        width: 1000,
        height: 850,
        linkCenter: true,
        defaultNode: {
          size: [150, 50],
          type: 'rect',
          style: {
            fill: '#DEE9FF',
            stroke: '#5B8FF9',
          },
        },
        defaultEdge: {
          type: 'circle-running',
          autoRotate: true,
          style: {
            stroke: '#b5b5b5',
            lineAppendWidth: 3, // Enlarge the range the edge to be hitted
          },
          labelCfg: {
            autoRotate: true,
            style: {
              // A white stroke with width 5 helps show the label more clearly avoiding the interference of the overlapped edge
              stroke: 'white',
              lineWidth: 5,
            },
          },
        },
        modes: {
          default: [
            'drag-node',
            {
              type: 'tooltip',
              formatText: function formatText(model) {
                const text = model.description
                return text
              },
              offset: 20,
              shouldBegin: e => {
                if (e.item.getModel().id === '1') return false
                const div = document.getElementsByClassName('g6-tooltip')[0]
                if (div) div.style.display = 'none'
                return true
              },
              shouldUpdate: e => {
                if (e.target.get('name') === 'text-shape') {
                  const div = document.getElementsByClassName('g6-tooltip')[0]
                  if (div) div.style.display = 'block'
                  return true
                }
                return false
              },
            },
          ],
        },
      })
      //render
      this.graph.data(this.data)
      this.graph.render()
    },
    clear() {
      if (this.graph) {
        this.graph.clear()
        this.container.innerHTML = ''
      }
    },
    add() {
      this.visibleTree = true
      this.treeForm.year = this.form.year
      this.treeForm.customerCode = this.form.customerCode
      this._getDupont()
    },
    handleChange() {
      this.treeForm.year = null
    },
    handleOpenChange(status) {
      this.isOpen = status
    },
    handlePanelChange(value) {
      this.isOpen = false
      this.treeForm.year = moment(value).format('YYYY')
      this._getDupont()
    },
    fittingString(str, maxWidth, fontSize) {
      let currentWidth = 0
      let res = str
      const pattern = new RegExp('[\u4E00-\u9FA5]+') // distinguish the Chinese charactors and letters
      str.split('').forEach((letter, i) => {
        if (currentWidth > maxWidth) return
        if (pattern.test(letter)) {
          // Chinese charactors
          currentWidth += fontSize
        } else {
          // get the width of single letter according to the fontSize
          currentWidth += G6.Util.getLetterWidth(letter, fontSize)
        }
        if (currentWidth > maxWidth) {
          res = `${str.substr(0, i)}\n${str.substr(i)}`
        }
      })
      return res
    },
    async _getDupont() {
      this.clear()
      const { data } = await getDupont(this.treeForm)
      this.result = {}
      this.result = data
      this.changeData()
      this.renderGraph()
    },
    changeData() {
      insertCss(`
        .g6-tooltip {
          border: 1px solid #e2e2e2;
          border-radius: 4px;
          font-size: 12px;
          color: #545454;
          background-color: rgba(255, 255, 255, 0.9);
          padding: 10px 8px;
          box-shadow: rgb(174, 174, 174) 0px 0px 10px;
        }
      `)
      const golbalFontSize = 14
      this.data = {}
      this.data = {
        nodes: [
          {
            id: '0',
            label: this.fittingString(
              `净资产收益率: ${this.result.returnOnEquity}`,
              90,
              golbalFontSize,
            ),
            x: 530,
            y: 50,
            description: this.result.returnOnEquity,
          },
          {
            id: 'k1',
            label: this.fittingString(
              `总资产收益率: ${this.result.returnOnAssets}`,
              90,
              golbalFontSize,
            ),
            x: 450,
            y: 160,
            description: this.result.returnOnAssets,
          },

          {
            id: '2',
            label: this.fittingString(
              `权益乘数: ${this.result.equityMultiplier}`,
              70,
              golbalFontSize,
            ),
            x: 620,
            y: 160,
            description: this.result.equityMultiplier,
          },
          {
            id: '3',
            label: this.fittingString(
              `销售净利率: ${this.result.netProfitMargin}`,
              80,
              golbalFontSize,
            ),
            x: 350,
            y: 260,
            description: this.result.netProfitMargin,
          },
          {
            id: '4',
            label: this.fittingString(
              `总资产周转率: ${this.result.totalAssetsTurnover}`,
              90,
              golbalFontSize,
            ),
            x: 720,
            y: 260,
            description: this.result.totalAssetsTurnover,
          },
          {
            id: '5',
            label: this.fittingString(
              `净利润: ${this.result.netIncome}`,
              50,
              golbalFontSize,
            ),
            x: 250,
            y: 360,
            description: this.result.netIncome,
          },
          {
            id: '6',
            label: this.fittingString(
              `营业收入: ${this.result.operatingRevenue}`,
              70,
              golbalFontSize,
            ),
            x: 430,
            y: 360,
            description: this.result.operatingRevenue,
          },
          {
            id: '7',
            label: this.fittingString(
              `营业收入: ${this.result.operatingRevenue}`,
              70,
              golbalFontSize,
            ),
            x: 650,
            y: 360,
            description: this.result.operatingRevenue,
          },
          {
            id: '8',
            label: this.fittingString(
              `平均资产总额: ${this.result.totalAssetsAvg}`,
              70,
              golbalFontSize,
            ),
            x: 820,
            y: 360,
            description: this.result.totalAssetsAvg,
          },
          {
            id: '9',
            label: this.fittingString(
              `营业收入: ${this.result.operatingRevenue}`,
              70,
              golbalFontSize,
            ),
            x: 150,
            y: 560,
            description: this.result.operatingRevenue,
          },
          {
            id: '10',
            label: this.fittingString(
              `全部成本: ${this.result.totalCost}`,
              70,
              golbalFontSize,
            ),
            x: 320,
            y: 560,
            description: this.result.totalCost,
          },
          {
            id: '11',
            label: this.fittingString(
              `投资收益: ${this.result.investmentIncome}`,
              70,
              golbalFontSize,
            ),
            x: 500,
            y: 560,
            description: this.result.investmentIncome,
          },
          {
            id: '12',
            label: this.fittingString(
              `所得税: ${this.result.taxIncome}`,
              50,
              golbalFontSize,
            ),
            x: 680,
            y: 560,
            description: this.result.taxIncome,
          },
          {
            id: '13',
            label: this.fittingString(
              `其他: ${this.result.other}`,
              40,
              golbalFontSize,
            ),
            x: 860,
            y: 560,
            description: this.result.other,
          },
          {
            id: '14',
            label: this.fittingString(
              `营业成本: ${this.result.operatingCosts}`,
              70,
              golbalFontSize,
            ),
            x: 220,
            y: 760,
            description: this.result.operatingCosts,
          },
          {
            id: '15',
            label: this.fittingString(
              `销售费用: ${this.result.sellingExpense}`,
              70,
              golbalFontSize,
            ),
            x: 400,
            y: 760,
            description: this.result.sellingExpense,
          },
          {
            id: '16',
            label: this.fittingString(
              `管理费用: ${this.result.handlingExpense}`,
              60,
              golbalFontSize,
            ),
            x: 580,
            y: 760,
            description: this.result.handlingExpense,
          },
          {
            id: '17',
            label: this.fittingString(
              `财务费用: ${this.result.financeExpense}`,
              70,
              golbalFontSize,
            ),
            x: 760,
            y: 760,
            description: this.result.financeExpense,
          },
        ],
        edges: [
          {
            id: 'e1',
            source: '0',
            target: 'k1',
          },
          {
            id: 'e2',
            source: '0',
            target: '2',
          },
          {
            id: 'e3',
            source: 'k1',
            target: '3',
          },
          {
            id: 'line12',
            source: 'k1',
            target: '2',
            label: 'X',
            curveOffset: 0,
          },
          {
            id: 'e4',
            source: '2',
            target: '4',
            description: 'This is edge from node 0 to node 2.',
          },
          {
            id: 'e5',
            source: '3',
            target: '5',
            description: 'This is edge from node 0 to node 2.',
          },
          {
            id: 'line34',
            source: '3',
            target: '4',
            label: 'X',
            curveOffset: 50,
          },
          {
            id: 'e6',
            source: '3',
            target: '6',
            description: 'This is edge from node 0 to node 2.',
          },
          {
            id: 'e7',
            source: '4',
            target: '7',
            description: 'This is edge from node 0 to node 2.',
          },
          {
            id: 'e8',
            source: '4',
            target: '8',
            description: 'This is edge from node 0 to node 2.',
          },
          {
            id: 'e9',
            source: '5',
            target: '9',
            description: 'This is edge from node 0 to node 2.',
          },
          {
            id: 'e10',
            source: '5',
            target: '10',
            description: 'This is edge from node 0 to node 2.',
          },
          {
            id: 'e11',
            source: '5',
            target: '11',
            description: 'This is edge from node 0 to node 2.',
          },
          {
            id: 'e12',
            source: '5',
            target: '12',
            description: 'This is edge from node 0 to node 2.',
          },
          {
            id: 'e13',
            source: '5',
            target: '13',
            description: 'This is edge from node 0 to node 2.',
          },
          {
            id: 'e14',
            source: '9',
            target: '14',
            description: 'This is edge from node 0 to node 2.',
          },
          {
            id: 'e15',
            source: '9',
            target: '15',
            description: 'This is edge from node 0 to node 2.',
          },
          {
            id: 'e16',
            source: '9',
            target: '16',
            description: 'This is edge from node 0 to node 2.',
          },
          {
            id: 'e17',
            source: '9',
            target: '17',
            description: 'This is edge from node 0 to node 2.',
          },
          {
            id: 'line56',
            source: '5',
            target: '6',
            label: '/',
          },
          {
            id: 'line78',
            source: '7',
            target: '8',
            label: '/',
          },
          {
            id: 'line910',
            source: '9',
            target: '10',
            label: '-',
          },
          {
            id: 'line1011',
            source: '10',
            target: '11',
            label: '+',
          },
          {
            id: 'line1112',
            source: '11',
            target: '12',
            label: '-',
          },
          {
            id: 'line1213',
            source: '12',
            target: '13',
            label: '+',
          },
        ],
      }
    },
    onClose() {
      this.visibleTree = false
    },
  },
}
</script>
<style lang="less" scoped>
.tree-content {
  height: 880px;
  width: 1000px;
}
</style>
>
